import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=7e25f44c&scoped=true&"
import script from "./SortIcon.vue?vue&type=script&lang=ts&"
export * from "./SortIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SortIcon.vue?vue&type=style&index=0&id=7e25f44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e25f44c",
  null
  
)

export default component.exports